import { render, staticRenderFns } from "./VImage.vue?vue&type=template&id=6e192396&"
import script from "./VImage.vue?vue&type=script&lang=js&"
export * from "./VImage.vue?vue&type=script&lang=js&"
import style0 from "./VImage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e192396')) {
      api.createRecord('6e192396', component.options)
    } else {
      api.reload('6e192396', component.options)
    }
    module.hot.accept("./VImage.vue?vue&type=template&id=6e192396&", function () {
      api.rerender('6e192396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VImage.vue"
export default component.exports